import { render, staticRenderFns } from "./ContactListItem.vue?vue&type=template&id=58200e3b&"
import script from "./ContactListItem.vue?vue&type=script&lang=js&"
export * from "./ContactListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports